export default __webpack_public_path__ + "static/media/Unchecked.5c27798f.svg";